/* LaserGlow location intro films (Clifton, Edgewater, Miami): smooth scroll engine v4 (frame blending, full-res canvas).
   Loaded from the theme on the three location pages. It mounts before the page's own inline
   intro script and marks the film as mounted, so the inline copy skips itself. */
(function () {
  "use strict";

  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ss = function (a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  function pad(n) { n = String(n); while (n.length < 4) n = "0" + n; return n; }

  function monotone(points) {
    var n = points.length, xs = [], ys = [], d = [], m = [], i;
    for (i = 0; i < n; i++) { xs.push(points[i][0]); ys.push(points[i][1]); }
    for (i = 0; i < n - 1; i++) d.push((ys[i + 1] - ys[i]) / ((xs[i + 1] - xs[i]) || 1e-6));
    m[0] = d[0]; m[n - 1] = d[n - 2];
    for (i = 1; i < n - 1; i++) m[i] = d[i - 1] * d[i] <= 0 ? 0 : (d[i - 1] + d[i]) / 2;
    for (i = 0; i < n - 1; i++) {
      if (d[i] === 0) { m[i] = 0; m[i + 1] = 0; continue; }
      var a = m[i] / d[i], b = m[i + 1] / d[i], s = a * a + b * b;
      if (s > 9) { var k = 3 / Math.sqrt(s); m[i] = k * a * d[i]; m[i + 1] = k * b * d[i]; }
    }
    return function (x) {
      if (x <= xs[0]) return ys[0];
      if (x >= xs[n - 1]) return ys[n - 1];
      var j = 1; while (x > xs[j]) j++;
      var h = xs[j] - xs[j - 1], t = (x - xs[j - 1]) / h, t2 = t * t, t3 = t2 * t;
      return (2 * t3 - 3 * t2 + 1) * ys[j - 1] + (t3 - 2 * t2 + t) * h * m[j - 1] + (-2 * t3 + 3 * t2) * ys[j] + (t3 - t2) * h * m[j];
    };
  }

  /* ---------- per-page film definitions ---------- */

  var GM = 6.49787, ZE = 31, KD = 56, KS = 92;
  function Gz(f) { var t = clamp(f / ZE, 0, 1); return GM * t * t * (2.4 - 1.4 * t); }

  var PIN = [[53.01,46.45,48.92],[54.78,44.77,51.14],[54.69,44.4,50.02],[54.62,44,50.07],[54.53,43.44,50],[54.45,42.75,50.06],[54.36,41.79,50.08],[54.21,40.64,49.99],[54.16,39.53,49.99],[54.12,38.57,50.01],[54.1,37.82,50.08],[54.04,37.2,50.07],[53.94,36.78,53.2],[53.8,36.44,56.14],[53.73,36.28,58.3]];
  function pin(f) {
    var u = clamp(f, 0, 56) / 4, i = Math.min(Math.floor(u), PIN.length - 2), t = u - i, a = PIN[i], b = PIN[i + 1];
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t), lerp(a[2], b[2], t)];
  }

  var FILMS = {
    clifton: {
      tl: [[0, 0], [0.05, 0.6], [0.30, 90], [0.36, 94], [0.52, 126.5], [0.56, 129.5], [0.72, 162.5], [0.77, 165.5], [0.93, 199.4], [1, 200]],
      beats: { 1: [-1, -1, .04, .09], 2: [.26, .30, .37, .41], 3: [.48, .52, .57, .61], 4: [.68, .72, .78, .82], 5: [.89, .93, 2, 2] },
      beatVar: "1",
      readout: function (f) {
        var m;
        if (f < KD) { m = f <= ZE ? 400000 * Math.exp(-1.21403 * Gz(f)) : lerp(150, 60, (f - ZE) / (KD - ZE)); }
        else if (f < KS) { m = lerp(60, 0, (f - KD) / (KS - KD)); }
        else { var n = Math.round(clamp((f - KS) / 108, 0, 1) * 60); return "T+" + (n < 10 ? "0" : "") + n + " MIN"; }
        return m >= 1000 ? "ALT " + Math.round(m / 1000) + " KM" : "ALT " + Math.max(0, Math.round(m)) + " M";
      },
      anchorX: function (mobile, fi) { return mobile && fi > 150 ? lerp(.5, .14, ss(150, 196, fi)) : .5; },
      overlay: "clifton"
    },
    edgewater: {
      tl: [[0, 0], [0.05, 0.6], [0.19, 31], [0.25, 31.6], [0.37, 62], [0.42, 62.6], [0.50, 92], [0.62, 150], [0.72, 202], [0.77, 213], [0.82, 213.6], [0.96, 248.6], [1, 249]],
      beats: { 1: [-1, -1, .04, .09], 2: [.16, .19, .25, .29], 3: [.34, .37, .42, .46], 6: [.62, .65, .70, .73], 4: [.77, .80, .84, .88], 5: [.93, .96, 2, 2] },
      beatVar: "5",
      readout: function (f) {
        if (f < 62) { var m = f < 31 ? lerp(600, 40, Math.pow(f / 31, .7)) : lerp(40, 0, (f - 31) / 31); return "ALT " + Math.max(0, Math.round(m)) + " M"; }
        var n = Math.round(clamp((f - 62) / 187, 0, 1) * 60);
        return "T+" + (n < 10 ? "0" : "") + n + " MIN";
      },
      anchorX: function () { return .5; },
      overlay: null
    },
    miami: {
      tl: [[0, 0], [0.05, 0.6], [0.28, 53.6], [0.34, 55.2], [0.50, 98.5], [0.54, 101.5], [0.72, 158.5], [0.77, 161.5], [0.93, 201.4], [1, 202]],
      beats: { 1: [-1, -1, .04, .09], 2: [.26, .30, .37, .41], 3: [.48, .52, .57, .61], 4: [.68, .72, .78, .82], 5: [.89, .93, 2, 2] },
      beatVar: "1",
      readout: function (f) {
        if (f <= 55) { var t = clamp(f / 55, 0, 1); return "ALT " + Math.round(lerp(120, 18, t * t * (3 - 2 * t) * .5 + t * .5)) + " M"; }
        if (f < 100) return "SUITE 401";
        var n = Math.round(clamp((f - 100) / 102, 0, 1) * 60);
        return "T+" + (n < 10 ? "0" : "") + n + " MIN";
      },
      anchorX: function () { return .5; },
      overlay: "miami"
    }
  };

  function filmFor() {
    var p = location.pathname;
    if (p.indexOf("teeth-whitening-clifton-nj") > -1) return FILMS.clifton;
    if (p.indexOf("teeth-whitening-edgewater-nj") > -1) return FILMS.edgewater;
    if (p.indexOf("in-office-laser-teeth-whitening-miami-fl") > -1) return FILMS.miami;
    return null;
  }

  /* ---------- engine ---------- */

  function mount(root, F) {
    if (root.__lgc) return;
    root.__lgc = 1;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector("[data-lgc-config]").textContent); } catch (e) {}

    var track = root.querySelector("[data-lgc-track]"), media = root.querySelector("[data-lgc-media]"),
        canvas = root.querySelector("[data-lgc-canvas]"), bar = root.querySelector("[data-lgc-bar]"),
        cue = root.querySelector("[data-lgc-cue]"), skip = root.querySelector("[data-lgc-skip]"),
        ro = root.querySelector("[data-lgc-readout]");
    var ov = root.querySelector("[data-lgc-ov]"), mp = root.querySelector("[data-lgc-map]"), mpi = mp && mp.firstElementChild;
    var lbls = root.querySelector("[data-lgc-lbls]"), cap = root.querySelector("[data-lgc-cap]");

    var beats = {};
    [].forEach.call(root.querySelectorAll("[data-lgc-beat]"), function (el) { beats[el.getAttribute("data-lgc-beat")] = el; });
    var hideT = {};
    for (var bk in beats) {
      hideT[bk] = beats[bk].querySelector("h1") ? [].filter.call(beats[bk].children, function (c) { return c.tagName !== "H1"; }) : [beats[bk]];
    }

    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ctx = canvas && canvas.getContext ? canvas.getContext("2d", { alpha: false }) : null;

    function pickSet() {
      var r = media.getBoundingClientRect(), tall = innerWidth < 768 || (r.width && r.height && r.width / r.height < 1);
      var s = tall ? cfg.m : cfg.d;
      return s && s.base && s.count ? s : null;
    }
    var set = media ? pickSet() : null;
    function dims(m) {
      var s0 = m ? cfg.m : cfg.d, im = imgs && imgs[0];
      if (s0 && s0.w && s0.h) return [s0.w, s0.h];
      if (im && im.naturalWidth && set === s0) return [im.naturalWidth, im.naturalHeight];
      return m ? [864, 1080] : [1920, 1080];
    }

    /* write cache: only touch the DOM when a value actually changes */
    function w(el, k, v, fn) { if (!el) return; var c = el.__lgw || (el.__lgw = {}); if (c[k] === v) return; c[k] = v; fn(v); }
    function css(el, p, v) { w(el, "s" + p, v, function (x) { el.style[p] = x; }); }
    function cvar(el, n, v) { w(el, "v" + n, v, function (x) { el.style.setProperty(n, x); }); }
    function cls(el, n, on) { w(el, "c" + n, on, function (x) { el.classList.toggle(n, x); }); }

    var pf = -1;
    function setPin(f) {
      if (!ov) return;
      var q = Math.round(f * 4) / 4;
      if (q === pf) return;
      pf = q;
      var p = pin(q), m = set === cfg.m;
      ov.style.setProperty("--dx", (m ? p[2] : p[0]).toFixed(2) + "%");
      ov.style.setProperty("--dy", p[1].toFixed(2) + "%");
    }

    function place() {
      if (!ov || !F.overlay) return;
      var r = media.getBoundingClientRect(), m = set === cfg.m, dd = dims(m), iw = dd[0], ih = dd[1],
          sc = Math.max(r.width / iw, r.height / ih), wd = iw * sc, ht = ih * sc,
          left = (r.width - wd) / 2 + "px", top = (r.height - ht) * (m ? .35 : .5) + "px";
      [ov, F.overlay === "clifton" ? mp : null].forEach(function (el) {
        if (!el) return;
        el.style.width = wd + "px"; el.style.height = ht + "px"; el.style.left = left; el.style.top = top;
        el.setAttribute("data-set", m ? "m" : "d");
      });
      if (F.overlay === "miami") { pf = -1; setPin(0); }
      root.classList.add("is-ov");
      var L = [].slice.call(ov.querySelectorAll(".lgc__lbl"));
      if (F.overlay === "miami" && cap) L.push(cap);
      var b1 = root.querySelector('[data-lgc-beat="1"]'), mr = media.getBoundingClientRect(), c = b1 && b1.getBoundingClientRect();
      for (var k = 0; k < L.length; k++) {
        var el = L[k];
        el.style.visibility = "";
        if (m) continue;
        var a = el.getBoundingClientRect();
        var bad = el !== cap && (a.bottom > mr.bottom - 20 || a.top < mr.top + 56 || a.right > mr.right - 16 || a.left < mr.left + 16);
        if (!bad && c && c.width) bad = a.right > c.left - 20 && a.left < c.right + 20 && a.bottom > c.top - 20 && a.top < c.bottom + 20;
        if (bad) el.style.visibility = "hidden";
      }
    }

    if (!ctx || !set || !track || reduce) {
      root.classList.add("is-static");
      if (set && ov && media && F.overlay === "miami") place();
      return;
    }

    if (!document.getElementById("lgc-smooth-css")) {
      var st = document.createElement("style");
      st.id = "lgc-smooth-css";
      st.textContent =
        ".lgc .lgc__canvas,.lgc [data-lgc-canvas]{will-change:transform;backface-visibility:hidden}" +
        ".lgc .lgc__stage{contain:layout paint}" +
        ".lgc .lgc__stage .lgc-ghost{-webkit-backdrop-filter:none!important;backdrop-filter:none!important;background:rgba(10,13,18,.5)!important}" +
        ".lgc .lgc__stage .lgc__cap-pin,.lgc .lgc__stage .lgc__mpin b,.lgc .lgc__stage .lgc__skip{-webkit-backdrop-filter:none!important;backdrop-filter:none!important}";
      document.head.appendChild(st);
    }

    if (skip) skip.addEventListener("click", function () {
      var r = track.getBoundingClientRect();
      window.scrollTo({ top: pageYOffset + r.bottom - innerHeight + 2, behavior: "smooth" });
    });

    var tl = monotone(F.tl);

    /* ---- frame loading ---- */
    var imgs = [], ok = [], bad = [], queue = [], busy = 0, MAX = 6, key = "";
    function url(i) {
      var a = set.alt;
      return (a && i <= a.upto ? a.base + pad(i) : set.base + pad(i - (a && a.shift || 0))) + ".webp" + (cfg.ver ? "?v=" + cfg.ver : "");
    }
    function pump() {
      while (busy < MAX && queue.length) {
        (function (i) {
          if (ok[i] || imgs[i]) return;
          busy++;
          var im = new Image(), k = key;
          im.decoding = "async";
          im.onload = function () {
            busy--;
            if (k === key) { ok[i] = 1; dirty = 1; if (i === 0) size(true); req(); }
            if (im.decode) im.decode().then(null, function () {});
            pump();
          };
          im.onerror = function () { busy--; if (k === key) bad[i] = 1; pump(); };
          im.src = url(i);
          imgs[i] = im;
        })(queue.shift());
      }
    }
    function order(n) {
      var seen = {}, out = [];
      [16, 8, 4, 2, 1].forEach(function (s) { for (var i = 0; i < n; i += s) if (!seen[i]) { seen[i] = 1; out.push(i); } });
      if (!seen[n - 1]) out.push(n - 1);
      return out;
    }
    var conn = navigator.connection, saver = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "")));
    var first = [], second = [], rest = [], engaged = false, loaded = document.readyState === "complete";
    function plan() {
      var k = set.base;
      if (k === key) return;
      key = k; imgs = []; ok = []; bad = []; queue = [];
      var all = order(set.count).filter(function (i) { return !saver || i % 2 === 0 || i === set.count - 1; });
      first = all.filter(function (i) { return i < 3; });
      second = all.filter(function (i) { return i >= 3 && (i % 12 === 0 || i === set.count - 1); });
      rest = all.filter(function (i) { return first.indexOf(i) < 0 && second.indexOf(i) < 0; });
      queue = first.slice();
      if (loaded || engaged) { queue = queue.concat(second, rest); second = []; rest = []; }
      pump();
    }
    function add(list) { if (list.length) { queue = queue.concat(list); pump(); } return []; }
    if (!loaded) addEventListener("load", function () {
      loaded = true;
      setTimeout(function () { second = add(second); }, 150);
      setTimeout(function () { rest = add(rest); }, 900);
    });
    var EV = ["wheel", "touchstart", "keydown", "pointerdown", "scroll"];
    function engage() {
      if (engaged) return;
      engaged = true;
      second = add(second); rest = add(rest);
      EV.forEach(function (e) { removeEventListener(e, engage, { passive: true }); });
    }
    EV.forEach(function (e) { addEventListener(e, engage, { passive: true }); });

    function prioritize(i, dir) {
      var want = [];
      for (var k = 0; k < 10; k++) {
        var j = i + (dir >= 0 ? k : -k);
        if (j >= 0 && j < set.count && !ok[j] && !imgs[j]) want.push(j);
      }
      if (!want.length) return;
      queue = want.concat(queue.filter(function (q) { return want.indexOf(q) < 0; }));
      pump();
    }
    function nearest(i, dir) {
      if (ok[i]) return i;
      var s = dir >= 0 ? 1 : -1;
      for (var d = 1; d < set.count; d++) {
        var behind = i - d * s, ahead = i + d * s;
        if (behind >= 0 && behind < set.count && ok[behind]) return behind;
        if (ahead >= 0 && ahead < set.count && ok[ahead]) return ahead;
      }
      return -1;
    }

    /* ---- canvas sizing ---- */
    var W = 0, H = 0, dpr = 1, cssW = 0, cssH = 0, dirty = 1, drawn = -1, drawnMix = -1;
    function size(force) {
      var s = pickSet();
      if (s && s !== set) { set = s; plan(); force = true; }
      var r = media.getBoundingClientRect();
      var same = Math.abs(r.width - cssW) < 1 && Math.abs(r.height - cssH) < 1;
      if (!same || force) place();
      if (same && W && !force) return;
      cssW = r.width; cssH = r.height;
      var m = set === cfg.m, dd = dims(m), iw = dd[0], ih = dd[1];
      var need = Math.max(iw / Math.max(1, cssW), ih / Math.max(1, cssH));
      dpr = clamp(Math.min(devicePixelRatio || 1, need), 1, 2);
      W = Math.max(1, Math.round(cssW * dpr)); H = Math.max(1, Math.round(cssH * dpr));
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      dirty = 1;
    }
    function draw(im, fi) {
      var iw = im.naturalWidth, ih = im.naturalHeight;
      if (!iw) return;
      var sc = Math.max(W / iw, H / ih), dw = iw * sc, dh = ih * sc, m = set === cfg.m;
      ctx.drawImage(im, (W - dw) * F.anchorX(m, fi), (H - dh) * (m ? .35 : .5), dw, dh);
    }

    /* ---- render loop ---- */
    var target = 0, cur = 0, raf = 0, visible = true, lastT = 0, dir = 1;

    function prog(r) { var span = r.height - innerHeight; return span > 0 ? clamp(-r.top / span, 0, 1) : 0; }

    function render(trackTop) {
      cvar(root, "--lgc-off", (trackTop > 0 ? Math.round(trackTop) : 0) + "px");
      var p = cur, f = tl(p), fe = clamp(f, 0, set.count - 1), want = Math.min(set.count - 1, Math.floor(fe)),
          frac = want >= set.count - 1 ? 0 : fe - want;
      if (!ok[want]) prioritize(want, dir);
      if (frac > 0 && !ok[want + 1]) prioritize(want + 1, dir);
      var i = nearest(want, dir), nx = -1, mixq = 0;
      if (i === want && frac > 0.04 && ok[want + 1]) {
        mixq = Math.round(frac * 12) / 12;
        if (mixq >= 1) { i = want + 1; mixq = 0; } else if (mixq > 0) nx = want + 1;
      }
      if (i >= 0 && (i !== drawn || mixq !== drawnMix || dirty)) {
        drawn = i; drawnMix = mixq; dirty = 0;
        ctx.globalAlpha = 1;
        ctx.fillStyle = "#0A0D12";
        ctx.fillRect(0, 0, W, H);
        draw(imgs[i], i);
        if (nx >= 0) { ctx.globalAlpha = mixq; draw(imgs[nx], nx); ctx.globalAlpha = 1; }
        if (!root.classList.contains("is-live")) root.classList.add("is-live");
      }
      var fs = i >= 0 ? i : f;
      if (ro) { var txt = F.readout(F.overlay === "miami" ? fs : (i >= 0 ? i : Math.round(f))); if (ro.textContent !== txt) ro.textContent = txt; }

      for (var k in beats) {
        var b = F.beats[k], el = beats[k];
        if (!b) continue;
        var o = Math.min(b[0] < 0 ? 1 : ss(b[0], b[1], p), 1 - ss(b[2], b[3], p)), off = o <= .05;
        css(el, "opacity", o.toFixed(3));
        cvar(el, "--dy", ((1 - o) * (p < (b[1] + b[2]) / 2 ? 20 : -20)).toFixed(1) + "px");
        cls(el, "is-on", o > .5);
        hideT[k].forEach(function (t) {
          w(t, "ah", off, function () { t.setAttribute("aria-hidden", off ? "true" : "false"); if (t.inert !== off) t.inert = off; });
        });
      }
      if (beats[F.beatVar]) cvar(root, "--b" + F.beatVar, beats[F.beatVar].style.opacity);

      if (F.overlay === "clifton") {
        if (ov) {
          var q = 1 - ss(1.2, 6, f), zs = Math.exp(Gz(Math.max(0, Math.round(f))));
          css(ov, "opacity", q.toFixed(3));
          css(ov, "transform", zs > 1.001 ? "scale(" + zs.toFixed(4) + ")" : "");
          css(ov, "visibility", q <= .001 ? "hidden" : "");
        }
        if (mp) {
          var mq = ss(ZE - 7.5, ZE - 5.5, f) * (1 - ss(ZE - .4, ZE + 1, f));
          css(mp, "opacity", mq.toFixed(3));
          css(mp, "visibility", mq <= .001 ? "hidden" : "visible");
          if (mq > .001 && mpi) css(mpi, "transform", "scale(" + Math.exp(Gz(Math.round(f)) - GM).toFixed(4) + ")");
        }
      } else if (F.overlay === "miami" && ov) {
        var q2 = 1 - ss(55.5, 61, fs);
        css(ov, "opacity", q2.toFixed(3));
        css(ov, "visibility", q2 <= .001 ? "hidden" : "");
        if (q2 > .001) setPin(fs);
        if (lbls) css(lbls, "opacity", (1 - ss(1, 7, fs)).toFixed(3));
      }

      if (bar) css(bar, "transform", "scaleX(" + p.toFixed(4) + ")");
      if (cue) css(cue, "opacity", p > .02 ? "0" : "1");
      cls(root, "is-moving", p > .02);
      cls(root, "is-end", p > .9);
      if (skip) cls(skip, "is-gone", p > .88);
    }

    function tick(now) {
      raf = 0;
      if (!visible) return;
      var r = track.getBoundingClientRect();
      var prev = target;
      target = prog(r);
      if (target !== prev) dir = target > prev ? 1 : -1;
      var dt = lastT ? Math.min(64, now - lastT) : 16.67;
      lastT = now;
      var d = target - cur, k = 1 - Math.pow(1 - 0.2, dt / 16.67);
      cur = Math.abs(d) < 3e-4 ? target : cur + d * k;
      render(r.top);
      if (Math.abs(target - cur) > 2e-4) req(); else lastT = 0;
    }
    function req() { if (!raf) raf = requestAnimationFrame(tick); }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        if (visible) { lastT = 0; req(); }
      }, { rootMargin: "200px" }).observe(track);
    }
    addEventListener("scroll", req, { passive: true });
    var rt = 0;
    addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(function () { size(); req(); }, 120); });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) { lastT = 0; req(); } });

    size(true);
    plan();
    var r0 = track.getBoundingClientRect();
    cur = target = prog(r0);
    if (cur > .03) engage();
    render(r0.top);
    req();

    root.__lgcApi = {
      seek: function (p) { cur = target = clamp(p, 0, 1); dirty = 1; render(track.getBoundingClientRect().top); },
      state: function () {
        return { p: cur, set: set === cfg.m ? "m" : "d", loaded: ok.filter(Boolean).length, total: set.count,
          canvas: W + "x" + H, dpr: dpr, frame: drawn, engine: "smooth-v4" };
      }
    };
  }

  function boot() {
    var F = filmFor();
    if (!F) return;
    [].forEach.call(document.querySelectorAll("[data-lgc],[data-lgc-v4]"), function (root) { mount(root, F); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
